// document.querySelectorAll('.collection-wrapper__item').forEach(element => {
//     var swiper = '';
//     element.addEventListener('mouseover', function(){
//         swiper = new Swiper('.variant-image__wrapper', {
//             centeredSlides: true,
//             slidesPerView: 1,
//             loop: true,
//             autoplay: {
//                 delay: 2000,
//                 disableOnInteraction: false
//             },
//             navigation: {
//                 nextEl: '.swiper-button-next',
//                 prevEl: '.swiper-button-prev',
//             },
//         });
//     })
    
//      element.addEventListener('mouseleave', function(){
//         console.log(swiper, 'swiper');
//         swiper.disable();
//      })
// })

var swipers = document.querySelectorAll('.variant-image__wrapper');

swipers.forEach(function (swiperElement) {
    var swiper = new Swiper(swiperElement, {
        autoplay: {
        delay: 1000, // Set autoplay delay to 3 seconds
        },
        loop: true, // Loop the carousel
    });

    swiper.autoplay.stop();
    // stop by default
    
    // Pause autoplay on mouse enter
    swiperElement.closest('.collection-wrapper__item').addEventListener('mouseover', function () {
        swiper.autoplay.start();
    });

    // Resume autoplay on mouse leave
    swiperElement.closest('.collection-wrapper__item').addEventListener('mouseleave', function () {
        swiper.autoplay.stop();
    });
});




